import { z } from "zod";
import { useEffect } from "react";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "../shared/form";
import { Checkbox } from "../shared/checkbox";

export function AddToColorCollectionForm({
  submitHandler,
  data,
  isFormSubmitting,
  setIsFormSubmitting,
  serverErrors,
  setServerErrors,
}) {
  const formFields = [...data?.fields];
  const formSchema = z.object({
    ...formFields.reduce((acc, field) => {
      if (field.fieldType === "hidden") {
        acc[field.fieldName] = z.any();
      }
      if (field.fieldType === "checkboxlist") {
        const required = field.fieldValidation.find(
          (validation) => validation.validationType === "required"
        );
        acc[field.fieldName] = z
          .string({
            message: required?.message,
          })
          .min(1, {
            message: required?.message,
          })
          .array({
            message: required?.message,
          })
          .nonempty({
            message: required?.message,
          });
      }
      return acc;
    }, {}),
  });
  const defaultFormValues = formFields.reduce((acc, field) => {
    if (field.fieldType === "checkboxlist") {
      acc[field.fieldName] = Array.isArray(field.fieldValue)
        ? [...field.fieldValue]
        : [];
    }
    if (field.fieldType === "hidden") {
      acc[field.fieldName] = field.fieldValue;
    }
    return acc;
  }, {});
  const form = useForm({
    resolver: zodResolver(formSchema),
    defaultValues: {
      ...defaultFormValues,
    },
  });
  const submitFormHandler = (body) => {
    submitHandler(body);
  };
  useEffect(() => {
    if (isFormSubmitting) {
      setIsFormSubmitting(false);
      form.handleSubmit(submitFormHandler)();
    }
  }, [isFormSubmitting]);

  return (
    <div>
      <Form {...form}>
        <form>
          {formFields.map((formField) => {
            if (formField.fieldType === "hidden" && !!formField.fieldValue) {
              return (
                <FormField
                  key={formField.fieldName}
                  control={form.control}
                  name={formField.fieldName}
                  render={({ field }) => (
                    <FormItem style={{ visibility: "hidden" }}>
                      <FormLabel>{formField.fieldLabel}</FormLabel>
                      <FormControl>
                        <input
                          type="hidden"
                          style={{ visibility: "hidden" }}
                          {...field}
                        />
                      </FormControl>
                    </FormItem>
                  )}
                />
              );
            }

            if (formField.fieldType === "checkboxlist") {
              return (
                <FormField
                  key={formField.fieldName}
                  control={form.control}
                  name={formField.fieldName}
                  render={({ field, fieldState }) => (
                    <FormItem>
                      <FormLabel style={{ visibility: "hidden" }}>
                        {formField.fieldLabel}
                      </FormLabel>
                      <div className="shadcn-checkbox-list">
                        {formField.fieldOptions
                          .filter((option) => !!option.optionValue)
                          .map((option) => (
                            <div
                              className="shadcn-checkbox-item"
                              key={option.optionValue}
                            >
                              <Checkbox
                                className="shadcn-checkbox"
                                checked={field.value?.includes(
                                  option.optionValue
                                )}
                                onCheckedChange={(checked) => {
                                  setServerErrors({});
                                  const computedFieldValue = Array.isArray(
                                    field.value
                                  )
                                    ? field.value
                                    : [];

                                  return checked
                                    ? field.onChange([
                                        ...computedFieldValue,
                                        option.optionValue,
                                      ])
                                    : field.onChange(
                                        computedFieldValue?.filter(
                                          (value) =>
                                            value !== option.optionValue
                                        )
                                      );
                                }}
                              />
                              <p className="shadcn-checkbox-label">
                                {option.optionLabel}
                              </p>
                            </div>
                          ))}
                      </div>
                      <FormMessage className="shadcn-input-error-message shadcn-input-error-message--mt-16">
                        {fieldState?.error?.message}
                        {Array.isArray(serverErrors?.[formField.fieldName])
                          ? serverErrors?.[formField.fieldName]?.join(" ")
                          : serverErrors?.[formField.fieldName]}
                      </FormMessage>
                    </FormItem>
                  )}
                />
              );
            }
            return <></>;
          })}
        </form>
      </Form>
    </div>
  );
}
